
































import { defineComponent } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-tip-alert';
export default defineComponent({
  components: {
    ALink,
  },
  props: {
    title: {
      type: String,
    },
    tip: {
      type: String,
    },
    link: {
      type: String,
    },
    liteLink: {
      type: String,
    },
    learnMore: {
      type: String,
    },
    actionLabel: {
      type: String,
    },
    actionIcon: {
      type: String,
    },
    actionContent: {
      type: String,
    },
    type: {
      type: String,
      default: 'info',
    },
    isTextCircle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('action');
    };
    return {
      name,
    };
  },
});
